import type { FC, PropsWithChildren, ReactNode } from 'react';

import type { Scopes } from 'state/userState/userState';
import { useUserHasScope } from 'state/userState/userState';

export interface WhenUserHasScopeProps {
  scope: Scopes | Scopes[];
  noAccess?: ReactNode;
}

export const WhenUserHasScope: FC<PropsWithChildren<WhenUserHasScopeProps>> = ({ scope, children, noAccess }) => {
  const showComponent = useUserHasScope(scope);

  if (showComponent) {
    return children;
  }

  if (showComponent === null) {
    return null;
  }

  return noAccess;
};
